import React from 'react'
import Button from 'component/Button'

const ProductProfileCard = ({
	id,
	active,
	customOnClick,
	logo,
	text,
	buttons,
}) => {
	return (
		<article className={`productProfile_card ${id} ${active}`}>
			<div
				role="button"
				tabIndex={0}
				onKeyDown={customOnClick}
				onClick={customOnClick}
			>
				<h2 className="productProfile_cardLogo">{logo}</h2>
				<p className="productProfile_cardText">{text}</p>
				<div className="productProfile_cardButtonsWrapper">
					{buttons.map((btn) => (
						<Button
							link={btn.link}
							key={btn.id}
							className={btn.class}
							title={btn.text}
						/>
					))}
				</div>
			</div>
		</article>
	)
}

export default ProductProfileCard
